export const PROCEDIMIENTO_CONEXION_ID = 1;
export const PROCEDIMIENTO_DESCONEXION_ID = 2;
